
export type GetUserById401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
